<mat-dialog-content>
  <lemon-dialog-header>
    @if (lisaa) {
      Lisää kirjanpitotili
    }
    @if (!lisaa) {
      Muokkaa kirjanpitotiliä
    }
  </lemon-dialog-header>

  <form novalidate>
    <div style="max-width: 250px; margin-bottom: 10px">
      <mat-form-field>
        <mat-label>Vanhempi</mat-label>
        <mat-select [formField]="lomake.vanhempi">
          <mat-option [value]="null">Ei vanhempaa</mat-option>
          @for (tili of tilitObservable | async; track tili) {
            <mat-option [value]="tili.numero">{{ tili.numero }} {{ tili.nimi }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Numero</mat-label>
        <input type="text" #numeroInput [formField]="lomake.numero" maxlength="4" minlength="1" decimalNumberField [numberOfDecimals]="0" matInput />
        @if (onkoVirhe(lomake.numero, 'maxlength') || naytaVirhe(lomake.numero, 'minlength')) {
          <mat-error> Asiakaskohtaisen tilinumeron on oltava 1-4 merkkiä pitkä. </mat-error>
        }
        @if (naytaVirhe(lomake.numero, 'required')) {
          <mat-error> Numero puuttuu </mat-error>
        }
        @if (naytaVirhe(lomake.numero, 'duplicate')) {
          <mat-error> Tilinumero on jo käytössä. </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi suomeksi</mat-label>
        <input type="text" #nimiFiInput [formField]="lomake.nimiFi" matInput />
        @if (naytaVirhe(lomake.nimiFi, 'required')) {
          <mat-error> Nimi puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nimi englanniksi</mat-label>
        <input type="text" #nimiEnInput [formField]="lomake.nimiEn" matInput />
        @if (naytaVirhe(lomake.nimiEn, 'required')) {
          <mat-error> Nimi puuttuu </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <mat-label>ALV-tyyppi</mat-label>
        <mat-select [formField]="lomake.alvtyyppi">
          @for (lokalisoituAlvtyyppi of lokalisoidutAlvtyypit; track lokalisoituAlvtyyppi) {
            <mat-option [value]="lokalisoituAlvtyyppi.tyyppi">{{ lokalisoituAlvtyyppi.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.alvtyyppi, 'required')) {
          <mat-error> Valinta puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Oletus ALV-käsittely</mat-label>
        <mat-select [formField]="lomake.alv" [compareWith]="vertaaAlvMaarityksia">
          @for (alv of alvt(); track alv) {
            <mat-option [value]="alv">{{ alv.nimi }}</mat-option>
          }
        </mat-select>
        @if (naytaVirhe(lomake.alv, 'required')) {
          <mat-error> Oletus puuttuu </mat-error>
        }
      </mat-form-field>
      <mat-checkbox [formField]="lomake.aktiivinen">Aktiivinen</mat-checkbox>
      <div style="margin-top: 5px">
        <mat-checkbox [formField]="lomake.reskontraActive">Reskontra päällä</mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button actionId="Päätilikartta: Peruuta kirjanpitotilin muokkaus" mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
  <app-secondary-button (click)="tallenna()" actionId="Päätilikartta: Tallenna kirjanpitotilin muutokset" [actionContext]="[lomake().value()]">Tallenna</app-secondary-button>
</mat-dialog-actions>
